import React from 'react';
import styled from 'styled-components';
import ImpContainer from '../ImpContainer/ImpContainer';
const REVEAL_DURATION = 300;
const REVEAL_DURATION_MS = `${REVEAL_DURATION}ms`;
const RevealContainer = styled(ImpContainer) `
  overflow-clip-margin: content-box;
  overflow: clip;
  width: 100%;
  max-height: ${(props) => (props.isVisible ? props.height : '0')};
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: max-height ${REVEAL_DURATION_MS} ease-in-out,
    opacity ${REVEAL_DURATION_MS} ease-in-out;
`;
export default function ImpReveal({ isVisible = false, height, children, }) {
    return (React.createElement(RevealContainer, { isVisible: isVisible, height: height }, children));
}
//# sourceMappingURL=ImpReveal.js.map